import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../reducers';
import * as fromBlog from '../../reducers';
import { Observable, Subscription } from 'rxjs';
import { LoadBlogs } from '../../actions/blog.actions';
import { Unit } from '../../../settings-module/models/unit';
import { BlogListingModel } from '../../models/blog-listing.model';

@Component({
  selector: 'mj-blog-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
})
export class OverviewComponent implements OnInit, OnDestroy {
  currentUnit: Observable<Unit>;
  blogListings: Observable<Array<BlogListingModel>>;
  isSticky: boolean;
  currentUnitSub$: Subscription;
  listSortingOptions = [
    { name: 'blog.date_published', value: 0, sortBy: 'published_at' },
    { name: 'dashboard.name', value: 1, sortBy: 'title' },
  ];
  @ViewChild('row', { static: false }) row;

  constructor(
    private store: Store<fromBlog.State>,
    private root_store: Store<fromRoot.State>
  ) {
    this.currentUnitSub$ = this.root_store
      .select(fromRoot.getSelectedUnit)
      .subscribe(unit => {
        if (unit) {
          this.store.dispatch(new LoadBlogs({ unit_id: unit.id }));
        }
      });

    this.currentUnit = this.root_store.select(fromRoot.getSelectedUnit);
    this.blogListings = this.store.select(fromBlog.selectAllBlogListings);
  }

  @HostListener('window:scroll')
  onScroll() {
    if (this.row && this.row.nativeElement) {
      this.isSticky =
        window.pageYOffset > this.row.nativeElement.offsetTop - 70;
    }
  }

  ngOnInit() {}

  ngOnDestroy() {
    if (this.currentUnitSub$) {
      this.currentUnitSub$.unsubscribe();
    }
  }
}
